import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { AlertController, IonInput, ModalController } from '@ionic/angular';
import { IonicSelectableComponent } from 'ionic-selectable';
import { CsiteSupplier, House, UserService, BaseUser } from '@arpada/arp-lib-common-qupro';
import { PortalProveedorService, MessagesService, UiService, InputAgreement, ConformesService } from '../../../services/api.services';
import { InputAgreementFileToUpload } from '../../../models/front-dto/api.dto';
import { NgForm } from '@angular/forms';

@Component({
  selector: 'app-subir-conforme',
  templateUrl: './subir-conforme.component.html',
  styleUrls: ['./subir-conforme.component.scss'],
})
export class SubirConformeComponent implements OnInit {

  @Input() isModal;
  @Input() afterLogin;
  csites: CsiteSupplier[] = [];
  houses: House[] = [];

  @ViewChild('csitesSelectable', { static: true }) csitesSelectable: IonicSelectableComponent;

  private modalId: string = null;
  agreementToCreateFormData = {
    csiteId: null,
    houseId: null,
    userId: null
  }
  readingPhoto = false;
  base64File: string = null;
  inputAgreementFileToUpload: InputAgreementFileToUpload = null;
  fileSelected = false;
  disabledAttachButton = false;
  csiteSelected = false;
  

  constructor(
    private modalCtrl: ModalController, 
    private messages: MessagesService,
    private portalProveedorService: PortalProveedorService,
    private alertCtrl: AlertController,
    private uiService: UiService,
    private userService: UserService,
    private conformesService: ConformesService,
    ) { }

  ngOnInit() {
    this.messages.onInitTranslateService().subscribe( () => {
      this.modalCtrl.getTop().then((top: HTMLIonModalElement) => {
        this.modalId = top.id; // Get modal ID for close it
        const globalOperatorSelected = this.portalProveedorService.getOperatorSel();
        this.userService.getLoggedUserDataCached().subscribe((userData: BaseUser) => {
          this.agreementToCreateFormData.userId = userData.partner_id;
        });
        this.portalProveedorService.getSupplierCsitesCached(globalOperatorSelected, 'combo-proformable-proveedor').subscribe(resp => {
          this.csites = resp.elements;
          console.log('csites: ', this.csites);
        });
      });
    });
  }

  getHouses(event: any) {
    const csiteId = event.detail.value;
    if (csiteId == -1) {
      this.csiteSelected = false;
      return;
    }
    this.houses = [];
    this.csiteSelected = true;
    this.portalProveedorService.getCachedHouses(csiteId, null).subscribe((resp: any) => {
      this.houses = resp.elements;
    });
  }
  houseSelected(event: any) { }

  ionInputFileChangeEvent(ionInput: IonInput, event: Event): void {
    this.disabledAttachButton = true;
    ionInput.getInputElement().then((input: HTMLInputElement) => {
      if (input && input.files) {
        this.fileChangeEvent(input.files, event);
      } else {
        this.portalProveedorService.logger.error('[CreateAdministrativeQueryModalComponent.ionInputFileChangeEvent] No existe el input o el atributo files.');
        this.uiService.presentAlert(this.messages.getUnexpectedErrorTitle(), null,
        this.messages.getCanNotGetImageErrorMessage());
      }
    }).catch((error: Error) => {
      this.portalProveedorService.logger.error('[CreateAdministrativeQueryModalComponent.ionInputFileChangeEvent] No existe el elemento para obtener la imagen.', error);
      this.uiService.presentAlert(this.messages.getUnexpectedErrorTitle(), null,
                                  this.messages.getCanNotGetImageErrorMessage());
    });
  }

  fileChangeEvent(files: FileList, event: Event): void {
    this.readingPhoto = false;
    this.inputAgreementFileToUpload = new InputAgreementFileToUpload();
    if (files.length <= 0) {
      this.base64File = null;
    } else if (files.length > 1) {
      this.base64File = null;
      this.showErrorAlert(this.messages.getErrorNewIssueMultipleFilesTitle(),
                          this.messages.getErrorNewIssueMultipleFilesMessage());
    } else {
      this.readingPhoto = true;
      const fileReader = new FileReader();
      fileReader.onloadend = (e) => {
        const srcText: string = fileReader.result.toString();
        this.fileSelected = true;
        this.disabledAttachButton = true;
        this.base64File = srcText;
        const arrayBase64 = this.base64File.split(',');
        this.inputAgreementFileToUpload.base64 = arrayBase64.pop();
        this.inputAgreementFileToUpload.mimetype = files[0].type;
        this.inputAgreementFileToUpload.filename = files[0].name;
        this.inputAgreementFileToUpload.file_extension = this.getFileExtension(files[0].name);
        this.readingPhoto = false;
      };
      fileReader.readAsDataURL(files[0]);
    }
  }

  close(){
    return this.modalCtrl.dismiss({
      data: null,
      role: 'cancel'
    });
  }

  cancelFileUpload() {
    this.fileSelected = false;
    this.readingPhoto = false;
    this.disabledAttachButton = false;
    this.base64File = null;
    this.inputAgreementFileToUpload = null;
  }

  uploadAgreement(fNewAgreement: NgForm) {
    const inputAgreement: InputAgreement = new InputAgreement();
    inputAgreement.house_id = this.agreementToCreateFormData.houseId;
    inputAgreement.supplier_partner_id = this.agreementToCreateFormData.userId;
    inputAgreement.input_agreement_file_to_upload = this.inputAgreementFileToUpload;
    this.conformesService.createSupplierConforme(inputAgreement).subscribe((resp: any) => {
      this.conformesService.uploadAgreementEvent.emit('OK');
      const message = 'conforme creado con éxito';
      this.showOkToast(message);
      this.modalCtrl.dismiss();
    }, error => {
      console.log('error: ', error);
      console.log(error['status']);
      this.uiService.presentAlert('Error', 'Error', error['error']['message']);
    });
    


  }

  showErrorAlert(title: string, message: string): void {
    const okLabel: string = this.messages.getOkButtonLabel();
    const errorHeader: string = this.messages.getErrorHeaderLabel();
    this.alertCtrl.create({
      header: errorHeader,
      subHeader: title,
      message,
      buttons: [{
        text: okLabel,
        cssClass: 'primary'
      }]
    }).then(alert => {
      alert.present();
    });
  }

  private getFileExtension(filename: string): string {
    const stringList = filename.split('.');
    return stringList.pop();
  }

  private showOkToast(message: string) {
    this.uiService.showSimpleBottomToast(message, 2000);
  }

}
